<label class="columns-manager_title">{{title === undefined ? ('components.columns-manager.title' | l10n) : title}}</label>
<form [formGroup]="form" class="columns-manager_form">

  <ng-container #fieldsColumnPlaceholder></ng-container>
  <ng-container #fieldsColumnPlaceholder></ng-container>

  <ng-template #fieldsColumnTemplate let-columns>
    <div class="columns-manager_form_fields-column">
      @for (column of columns; track column) {
        <div class="columns-manager_form_field"
          [class.-is-group-dependent]="column.isGroupDependent">
          <label class="columns-manager_form_field_control">
            <input class="columns-manager_form_field_control_checkbox" type="checkbox"
              id="{{column.formFieldId}}"
              [formControlName]="column.key"/>
            <span class="columns-manager_form_field_control_checkbox_sign"></span>
          </label>
          <label class="columns-manager_form_field_label" for="{{column.formFieldId}}">
            {{column.label | l10n}}
          </label>
        </div>
      }
    </div>
  </ng-template>

</form>
